<template>
  <div id="keyword_management">
    <div class="row m-b-20">
      <div class="col-md-8">
        <div class="row m-b-50">
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-7 component-header component-header-left">
                <h6>Daftar Topik dan Keyword</h6>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="component-subtitle">
              <p class="m-b-15">
                Berikut merupakan daftar kata kunci atau keyword beserta topik
                yang dimonitor dalam proyek ini.
              </p>
            </div>
            <div v-if="keyword_display" class="col-md-12 p-l-0 p-r-0">
              <p class="m-b-0 bold">
                Limit Keyword Media Sosial (Terpakai: {{ keyword_terpakai }})
              </p>
              <div class="progress m-b-0">
                <div
                  :class="'progress-bar ' + keyword_display.class"
                  :style="'width:' + keyword_display.persentase + '%'"
                />
              </div>
              <span>0</span
              ><span v-if="project_detail" class="pull-right">{{
                project_detail.keyword_limit
              }}</span>
            </div>
          </div>

          <div class="col-md-12">
            <tab-horizontal-component :tabs="tabs" />
          </div>
        </div>
      </div>
      <div class="col-md-4 p-l-25">
        <div class="row m-b-50">
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-12 component-header component-header-left">
                <h6>Manage Channel</h6>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="component-subtitle">
              <p class="m-b-15">
                Berikut merupakan daftar channel atau sumber data yang akan
                dikumpulkan.
              </p>
            </div>
          </div>
          <loader-component v-if="!project_detail" />
          <div v-else class="col-md-12" id="manage-channel">
            <div class="b-b b-t b-grey p-l-20 p-r-20 p-b-15 p-t-15">
              <div
                class="form-check switch switch-lg complete full-width right d-flex m-b-0"
              >
                <input
                  type="checkbox"
                  :checked="project_detail.crawler.twitter.status == 1"
                  id="pagesSwitchTwitter"
                  @click="toggleChannel('twitter')"
                />
                <label for="pagesSwitchTwitter" class="full-width">
                  <i class="bi bi-twitter" /> Twitter
                </label>
              </div>
            </div>
            <div class="b-b b-grey p-l-20 p-r-20 p-b-15 p-t-15">
              <div
                class="form-check switch switch-lg complete full-width right d-flex m-b-0"
              >
                <input
                  type="checkbox"
                  :checked="project_detail.crawler.facebook.status == 1"
                  id="pagesSwitchFacebook"
                  @click="toggleChannel('facebook')"
                />
                <label for="pagesSwitchFacebook" class="full-width">
                  <i class="bi bi-facebook" /> Facebook
                </label>
              </div>
            </div>
            <div class="b-b b-grey p-l-20 p-r-20 p-b-15 p-t-15">
              <div
                class="form-check switch switch-lg complete full-width right d-flex m-b-0"
              >
                <input
                  type="checkbox"
                  :checked="project_detail.crawler.instagram.status == 1"
                  id="pagesSwitchInstagram"
                  @click="toggleChannel('instagram')"
                />
                <label for="pagesSwitchInstagram" class="full-width">
                  <i class="bi bi-instagram" /> Instagram
                </label>
              </div>
            </div>
            <div class="b-b b-grey p-l-20 p-r-20 p-b-15 p-t-15">
              <div
                class="form-check switch switch-lg complete full-width right d-flex m-b-0"
              >
                <input
                  type="checkbox"
                  :checked="project_detail.crawler.youtube.status == 1"
                  id="pagesSwitchYoutube"
                  @click="toggleChannel('youtube')"
                />
                <label for="pagesSwitchYoutube" class="full-width">
                  <i class="bi bi-youtube" /> Youtube
                </label>
              </div>
            </div>
            <div class="b-b b-grey p-l-20 p-r-20 p-b-15 p-t-15">
              <div
                class="form-check switch switch-lg complete full-width right d-flex m-b-0"
              >
                <input
                  type="checkbox"
                  :checked="project_detail.crawler.linkedin.status == 1"
                  id="pagesSwitchTiktok"
                  @click="toggleChannel('tiktok')"
                />
                <label for="pagesSwitchTiktok" class="full-width">
                  <i class="bi bi-tiktok" /> Tiktok
                </label>
              </div>
            </div>
            <div class="b-b b-grey p-l-20 p-r-20 p-b-15 p-t-15">
              <div
                class="form-check switch switch-lg complete full-width right d-flex m-b-0"
              >
                <input
                  type="checkbox"
                  :checked="project_detail.crawler.linkedin.status == 1"
                  id="pagesSwitchLinkedin"
                  @click="toggleChannel('linkedin')"
                />
                <label for="pagesSwitchLinkedin" class="full-width">
                  <i class="bi bi-linkedin" /> LinkedIn
                </label>
              </div>
            </div>
            <div class="b-b b-grey p-l-20 p-r-20 p-b-15 p-t-15">
              <div
                class="form-check switch switch-lg complete full-width right d-flex m-b-0"
              >
                <input
                  type="checkbox"
                  :checked="project_detail.crawler.google.news_status == 1"
                  id="pagesSwitchNews"
                  @click="toggleChannel('news')"
                />
                <label for="pagesSwitchNews" class="full-width">
                  <i class="bi bi-globe-americas" /> Online News
                </label>
              </div>
            </div>
            <div class="b-b b-grey p-l-20 p-r-20 p-b-15 p-t-15">
              <div
                class="form-check switch switch-lg complete full-width right d-flex m-b-0"
              >
                <input
                  type="checkbox"
                  :checked="project_detail.crawler.google.forum_status == 1"
                  id="pagesSwitchForum"
                  @click="toggleChannel('forum')"
                />
                <label for="pagesSwitchForum" class="full-width">
                  <i class="bi bi-chat-dots-fill" /> Forum
                </label>
              </div>
            </div>
            <div class="b-b b-grey p-l-20 p-r-20 p-b-15 p-t-15">
              <div
                class="form-check switch switch-lg complete full-width right d-flex m-b-0"
              >
                <input
                  type="checkbox"
                  :checked="project_detail.crawler.google.blog_status == 1"
                  id="pagesSwitchBlog"
                  @click="toggleChannel('blog')"
                />
                <label for="pagesSwitchBlog" class="full-width">
                  <i class="bi bi-rss" /> Blog
                </label>
              </div>
            </div>
            <div
              v-if="project_detail.tipe == 1"
              class="b-b b-grey p-l-20 p-r-20 p-b-15 p-t-15"
            >
              <div
                class="form-check switch switch-lg complete full-width right d-flex m-b-0"
              >
                <input
                  type="checkbox"
                  :checked="project_detail.crawler.formed.cetak_status == 1"
                  id="pagesSwitchCetak"
                  @click="toggleChannel('media_cetak')"
                />
                <label for="pagesSwitchCetak" class="full-width">
                  <i class="bi bi-newspaper icon-media_cetak" /> Media Cetak
                </label>
              </div>
            </div>
            <div
              v-if="project_detail.tipe == 1"
              class="b-b b-grey p-l-20 p-r-20 p-b-15 p-t-15"
            >
              <div
                class="form-check switch switch-lg complete full-width right d-flex m-b-0"
              >
                <input
                  type="checkbox"
                  :checked="project_detail.crawler.formed.tv_status == 1"
                  id="pagesSwitchTv"
                  @click="toggleChannel('media_tv')"
                />
                <label for="pagesSwitchTv" class="full-width">
                  <i class="bi bi-tv" /> Media TV
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-8 component-header component-header-left">
                <h6>Tandai Kata</h6>
              </div>
              <div class="col-md-4 component-header component-header-right">
                <button
                  aria-label=""
                  @click="addKata"
                  class="btn btn-success btn-icon-left"
                  type="button"
                >
                  <i class="bi bi-plus"></i> <span class="">Tambah Kata</span>
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="component-subtitle">
              <p class="m-b-15">
                Berikut merupakan daftar kata yang ditandai dari data yang
                dikumpulkan.
              </p>
            </div>
          </div>
          <div class="col-md-12">
            <table class="table table-bordered" id="table_tandai_kata">
              <thead>
                <tr>
                  <th>Kata</th>
                  <th width="10%">Aksi</th>
                </tr>
              </thead>
              <tbody v-if="data_kata == null">
                <tr>
                  <td colspan="2">
                    <loader-component />
                  </td>
                  <td style="display: none" />
                </tr>
              </tbody>
              <tbody v-else>
                <tr v-if="!data_kata.length">
                  <td colspan="2">Mohon maaf, data tidak tersedia!</td>
                  <td style="display: none" />
                </tr>
                <tr v-else v-for="(row, index) in data_kata" :key="index">
                  <td>{{ row.word }}</td>
                  <td>
                    <button
                      class="btn-danger"
                      @click="deleteKata(row._id.$oid)"
                    >
                      <i class="bi bi-trash" />
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <modal-dynamic-component v-if="currentModal" :modal="currentModal" />
  </div>
</template>

<script>
import $ from "jquery";
import "datatables";
import modal_dynamic from "@/views/components/modal_dynamic.vue";
import modal_add_kata from "@/views/components/settings/keyword/modal_add_kata.vue";
import table_keyword from "@/views/components/settings/keyword/table_keyword.vue";
import table_topic from "@/views/components/settings/keyword/table_topic.vue";
import tab_horizontal from "@/views/components/tab_horizontal.vue";
import loader_component from "@/views/components/loader.vue";
import swal from "sweetalert";
import notif from "@/assets/js/notif.js";
$.pgNotification = notif;

var tabs = [
  {
    name: "Keyword",
    icon_class: "bi bi-key",
    component: table_keyword,
  },
  {
    name: "Topik",
    icon_class: "bi bi-list",
    component: table_topic,
  },
];

export default {
  name: "KeywordKabayan",
  components: {
    "modal-dynamic-component": modal_dynamic,
    "tab-horizontal-component": tab_horizontal,
    "loader-component": loader_component,
  },
  data() {
    return {
      currentModal: null,
      tabs: tabs,
      data_kata: null,
      project_detail: null,
      keyword_terpakai: 0,
      keyword_display: {},
      id_project: this.$store.getters.user.id_project,
    };
  },
  methods: {
    addKata: function () {
      this.currentModal = {};
      this.currentModal.title = "Tandai Kata";
      this.currentModal.subtitle = "Silahkan Masukan kata yang akan ditandai";
      this.currentModal.component = modal_add_kata;
      $("#modalSlideUp").modal("show");
    },
    getKata: function () {
      let self = this;
      let api = process.env.VUE_APP_API_URL + "marked-words/" + this.id_project;
      this.$http
        .get(api)
        .then(function (response) {
          if (response.status != 204) {
            self.data_kata = response.data;
          } else {
            self.data_kata = [];
          }
        })
        .catch(function (err) {
          console.log(err);
          self.data_kata = [];
        });
    },
    deleteKata: function (id) {
      let self = this;
      swal({
        title: "Apakah anda yakin?",
        text: "Akan menghapus kata tersebut dari daftar kata yang ditandai.",
        icon: "warning",
        buttons: ["Tidak", "Ya"],
        dangerMode: true,
      }).then((yess) => {
        if (yess) {
          let params = {
            _id: id,
          };
          let api = process.env.VUE_APP_API_URL + "marked-words-delete";
          this.$http
            .post(api, params)
            .then(function (response) {
              if (response.status == 200) {
                self.data_kata = [];
                self.getKata();
                $("body")
                  .pgNotification({
                    style: "bar",
                    message:
                      '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Kata berhasil dihapus.',
                    position: "top",
                    timeout: 5000,
                    type: "success",
                  })
                  .show();
              }
            })
            .catch(function () {
              $("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan saat menghapus kata.',
                  position: "top",
                  timeout: 5000,
                  type: "danger",
                })
                .show();
            });
        }
      });
    },
    getChannelStatus: function () {
      let api =
        process.env.VUE_APP_API_URL + "project-detail/" + this.id_project;
      this.$http
        .get(api)
        .then((response) => {
          if (response.status != 204) {
            this.project_detail = response.data.project_detail;
            this.keyword_terpakai = response.data.keyword_usage;

            this.keyword_display.persentase =
              this.keyword_terpakai > 0
                ? (this.keyword_terpakai / this.project_detail.keyword_limit) *
                  100
                : 0;

            if (this.keyword_display.persentase > 80) {
              this.keyword_display.class = "progress-bar-danger";
            } else {
              this.keyword_display.class = "progress-bar-success";
            }
          } else {
            this.project_detail = {};
          }
        })
        .catch(function (err) {
          console.log(err);
          this.project_detail = {};
        });
    },
    toggleChannel: function (source) {
      let toggle = 0;
      if ($(event.target)[0].checked == true) {
        toggle = 1;
      }

      let params = {
        _id: this.id_project,
        source: source,
        value: toggle,
      };
      let api = process.env.VUE_APP_API_URL + "source-toggle";
      this.$http
        .post(api, params)
        .then((response) => {
          if (response.status == 200) {
            $("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Channel berhasil diupdate.',
                position: "top",
                timeout: 5000,
                type: "success",
              })
              .show();
          }
        })
        .catch(() => {
          $("body")
            .pgNotification({
              style: "bar",
              message:
                '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan saat mengubah status channel.',
              position: "top",
              timeout: 4000,
              type: "danger",
            })
            .show();
        });
    },
  },
  created: function () {
    this.getKata();
    this.getChannelStatus();
  },
  mounted: function () {
    $("#table_tandai_kata").DataTable({
      lengthChange: false,
      searching: false,
      columnDefs: [{ orderable: false, targets: -1 }],
    });
    $(function () {
      $("#nama_topik").select2();
    });
  },
};
</script>

<style>
@import "../../../assets/css/jquery.dataTables.css";
.add-keyword > tbody > tr > td {
  padding-left: 5px;
  padding-right: 5px;
  text-align: center;
}
.add-keyword > tbody > tr > td > span {
  font-size: 11px;
}
.table thead tr th {
  padding-left: 20px;
}
.table tbody tr td {
  padding-top: 10px;
  padding-bottom: 10px;
}
#manage-channel i {
  width: 20px;
}
</style>